import React from 'react';
import OtpEntry from '@shared/components/auth/OtpEntry';

const OtpCOnfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/otp',
			element: (
				<React.Suspense fallback={<div>Loading...</div>}>
					<OtpEntry />
				</React.Suspense>
			),
		},
	],
};

export default OtpCOnfig;
